import styled, { css } from 'styled-components'

export const Wrapper = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;

  .edit-button {
    margin-left: auto;
    margin-right: 0;
    color: ${({ theme }) => theme.colors.darkGreen};
    text-decoration: underline;
  }
`

export const NotificationType = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    p {
      font-weight: 400;
      padding: 20px 0px;
      color: ${theme.colors.primary};
      font-size: ${theme.font.sizes.small};
    }

    & > div {
      display: flex;
      align-items: center;

      div + div {
        margin-left: 12px;
      }
    }
  `}
`

export const Content = styled.div`
  width: 100%;
  padding: 24px 0;
`

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      cursor: pointer;
      color: ${theme.colors.gray};
      font-size: ${theme.font.sizes.xsmall};
    }
  `}
`

export const ConfirmationModal = styled.div`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
    button {
      width: 49%;
    }
  }
`
